import type { ReactNode } from 'react';
import { Box, Stack, Text } from '@mantine/core';

export const MobileCard = ({
  children,
  background
}: {
  children: ReactNode;
  /** Npr. DRAFT_ROW_BACKGROUND za karticu s nespremljenom promjenom. */
  background?: string;
}) => (
  <Stack
    gap={8}
    p={12}
    style={{
      borderRadius: 8,
      border: '1px solid var(--color-border-soft)',
      backgroundColor: background ?? 'var(--color-bg-surface)'
    }}
  >
    {children}
  </Stack>
);

export const MobileCardList = ({ children }: { children: ReactNode }) => (
  <Stack hiddenFrom="sm" gap={10} p={16} className="mobile-card-list">
    {children}
  </Stack>
);

export const MobileField = ({
  label,
  align,
  children
}: {
  label: ReactNode;
  align?: 'right';
  children: ReactNode;
}) => (
  <Stack gap={2} style={{ minWidth: 0, alignItems: align === 'right' ? 'flex-end' : undefined }}>
    <Text fz={11} fw={600} style={{ color: 'var(--color-text-muted)', letterSpacing: 0.4 }}>
      {label}
    </Text>
    {children}
  </Stack>
);

export const MobileCodeBadge = ({ children }: { children: ReactNode }) => (
  <Box
    px={10}
    py={3}
    style={{
      alignSelf: 'flex-start',
      borderRadius: 999,
      backgroundColor: 'var(--color-bg-surface-2)'
    }}
  >
    <Text fz={11} fw={600} style={{ color: 'var(--color-text-secondary)' }}>
      {children}
    </Text>
  </Box>
);
